import React from "react";
import "../OrderComponents/OrderTabs.css";
import { useState } from "react";
import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import api from "../../seller-apis/api";

const TransactionTabs = (props) => {
  const stateData = useSelector((state) => state);
  
  const [ordersCount, setOrdersCount] = useState(null);

  const location = useLocation();
  var path = location.pathname.split("/");
  const pageName = path[path.length - 1];

  
  
  return (
    <div className="new-tabs ">
      <div className="tab-container" style={{ position: "relative" }}>
      <NavLink
            to="daily-report"
            className={`tabs ${pageName == "daily-report" ? "active" : ""}`}
          >
            Daily Report
            {/* <div class="order-menu-count menu-count-border">
              {0}
            </div> */}
          </NavLink>
          <NavLink
            to="vendor-transaction"
            className={`tabs ${pageName == "vendor-transaction" ? "active" : ""}`}
          >
            Actual Transaction
            {/* <div class="order-menu-count menu-count-border">
              {0}
            </div> */}
          </NavLink>
          <NavLink
            to="tv-transaction"
            className={`tabs ${pageName == "tv-transaction" ? "active" : ""}`}
          >
           Credited By TV
            {/* <div class="order-menu-count menu-count-border">
              {0}
            </div> */}
          </NavLink>
      </div>
    </div>
  );
};

export default TransactionTabs;
